import { get } from 'env-var';
import logger from 'helpers/logger';

let NODE_ENV: string;
let NEXT_PUBLIC_SITENAME: string;

// Read variables using env-var API
if (typeof window === 'undefined') {
	// Only perform assignment and check serverside / at build time
	NODE_ENV = get('NODE_ENV').required().asString();
	NEXT_PUBLIC_SITENAME = get('NEXT_PUBLIC_SITENAME').required().asString();
} else {
	try {
		// Force NextJs to bake in public vars client side using direct reference to process.env
		// https://github.com/evanshortiss/env-var/issues/162
		NEXT_PUBLIC_SITENAME = process.env.NEXT_PUBLIC_SITENAME;

		if (typeof NEXT_PUBLIC_SITENAME === 'undefined') {
			logger.error('Reference error - NEXT_PUBLIC_SITENAME is undefined');
			throw new Error(`NEXT_PUBLIC_SITENAME is undefined`);
		}

		// Without this, NODE_ENV stays undefined in the browser while the server sees
		// 'production', so any component branching on it renders differently on each
		// side and breaks hydration. See DynamicModuleFeature and PageTypeFeature.
		NODE_ENV = process.env.NODE_ENV;

		if (typeof NODE_ENV === 'undefined') {
			logger.error('Reference error - NODE_ENV is undefined');
			throw new Error(`NODE_ENV is undefined`);
		}
	} catch (e) {
		logger.error(e);
	}
}

export { NODE_ENV, NEXT_PUBLIC_SITENAME };
